import React from 'react';

/** ISO-3166 alpha-2 → regional-indicator flag emoji (🇨🇦 etc). */
export function isoToFlag(iso) {
  if (!iso || iso.length !== 2) return '🌍';
  const base = 0x1f1e6;
  const cc = iso.toUpperCase();
  return String.fromCodePoint(base + cc.charCodeAt(0) - 65, base + cc.charCodeAt(1) - 65);
}

/**
 * CountryTag — a flag + country-name pill. Yapp's signature way of showing
 * *which country a message came from* (identity stays anonymous, location
 * does not). `pin` adds a location marker; `tone="glass"` for over the globe.
 */
export function CountryTag({
  iso,
  name,
  pin = false,
  tone = 'soft',
  size = 'md',
  style = {},
  ...rest
}) {
  const sizes = {
    sm: { font: 'var(--text-xs)', pad: '0.2rem 0.6rem', flag: '0.95rem' },
    md: { font: 'var(--text-sm)', pad: '0.35rem 0.8rem', flag: '1.1rem' },
    lg: { font: 'var(--text-md)', pad: '0.5rem 1rem', flag: '1.4rem' },
  };
  const s = sizes[size] || sizes.md;

  const tones = {
    soft:  { bg: 'var(--brand-50)', fg: 'var(--brand-700)', border: '1px solid var(--brand-100)' },
    glass: { bg: 'rgba(0,0,0,0.4)', fg: '#fff', border: '1px solid var(--border-on-dark)' },
    solid: { bg: 'var(--brand-gradient)', fg: '#fff', border: '1px solid transparent' },
  };
  const t = tones[tone] || tones.soft;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.45rem',
        padding: s.pad,
        background: t.bg,
        color: t.fg,
        border: t.border,
        borderRadius: 'var(--radius-pill)',
        fontFamily: 'var(--font-sans)',
        fontSize: s.font,
        fontWeight: 'var(--weight-semibold)',
        lineHeight: 1.3,
        backdropFilter: tone === 'glass' ? 'var(--blur-glass)' : 'none',
        whiteSpace: 'nowrap',
        ...style,
      }}
      {...rest}
    >
      {pin && <i className="fa-solid fa-location-dot" style={{ fontSize: '0.85em', opacity: 0.8 }} />}
      <span style={{ fontSize: s.flag, lineHeight: 1 }}>{isoToFlag(iso)}</span>
      {name}
    </span>
  );
}
